import React, { useEffect, useState } from "react";
// import Share_Btn from '../../../common/Common_Component/Share_Btn/Share_Btn'
import "./Product_Inner_Description.css";
import { Button } from "react-bootstrap";
// import Select_Product_Modal from '../../../common/Common_Modal/Select_Product_Modal/Select_Product_Modal'
// import Close_Without_Adding_To_Cart_Modal from '../../../common/Common_Modal/Close_Without_Adding_To_Cart_Modal/Close_Without_Adding_To_Cart_Modal'
import {
  faBasketShopping,
  faShareNodes,
  faSortDown,
  faStar,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link, Navigate } from "react-router-dom";
// import GotoCartModal from '../../../common/Common_Modal/GotoCartModal/GotoCartModal'
import Product_Specification from "./product_specification/Product_Specification";
import IncrementDecrementBtn from "../../common_components/Increment_Decrement_Btn/Increment_Decrement_Btn";
import Product_Description_Text from "../product_description_text/Product_Description_Text";
import Green_Btn from "../../common_components/common_btn/green_btn/Green_Btn";
import Share_Btn from "../../common_components/common_btn/share_btn/Share_Btn";
import GotoCartModal from "../../common_components/common_modal/goto_cart_modal/GotoCartModal";

import { useDispatch, useSelector } from "react-redux";
import { getAllCart, postCart } from "../../../features/cart/cartSlice";
import { encodeId } from "../../../utils/common";
import Select_Product_Cart_Modal from "../../common_components/common_modal/select_product_by_weight_modal/Select_Product_By_Cart_Modal";



const Product_Inner_Description = ({ avgrating, ...props }) => {
  const [makeItComboModalShow, setMakeItComboModalShow] = useState(false);
  const [addDipsModalShow, setAddDipsModalShow] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [addCartBTNShow, setaddCartBTNShow] = useState(false);
  const [showGoToCartModal, setshowGoToCartModal] = useState(false);
  const [
    show_Select_Product_By_Weight_Modal,
    set_show_Select_Product_By_Weight_Modal,
  ] = useState(false);

  const [selectedVariant, setSelectedVariant] = useState();

  const products = [
    {
      product_name: "Add Bacon Slices",
      weight: "(+KWD 0.001)",
      image: "/assets/images/Restaurants/Products/img1.png",
    },

    {
      product_name: "Add Cheese",
      weight: "(+KWD 0.001)",
      image: "/assets/images/Restaurants/Products/img2.png",
    },

    {
      product_name: "Add Melted Cheese",
      weight: "(+KWD 0.001)",
      image: "/assets/images/Restaurants/Products/img2.png",
    },
  ];
  const isSignIn = useSelector((state) => state.auth.is_signin);

  const dispatch = useDispatch();
  // const allCart = useSelector((state) => state.cart.allCarts);
  useEffect(() => {}, [dispatch]);

  return (
    <div className="Product_Description">
      <div className="top_heading">
        <div className="heading_div">
          <p className="heading">{props?.product?.name}</p>
        </div>
        <div className="top_btn_holder">
          <div className="share_btn">
            <Share_Btn
              faIcon={faShareNodes}
              productUrl={`${
                window.location.origin
              }/product-description/${encodeId(props?.product?.id)}`}
              productName={props?.product?.name}
            />
          </div>
        </div>
      </div>

      <div className="product_price_info">
        <div className="price_section">
          <div className="selling_price">
            <p>
              ₹
              {props?.product?.Product_Variants?.[0]?.price ??
                props?.Product_Variants?.[0]?.price ??
                "-"}
            </p>
          </div>

          <div className="mrp">
            <p>
              ₹
              {props?.product?.Product_Variants?.[0]?.mrp ??
                props?.Product_Variants?.[0]?.mrp ??
                "-"}
            </p>
          </div>

          {/* <div className="discount">
            <p>-20 %</p>
          </div> */}

          {/* <div className="stock">
            <p>In Stock</p>
          </div> */}
        </div>

        <div className="reviews_div">
          <div className="star_div">
            <FontAwesomeIcon icon={faStar} className="star_icon" />
          </div>

          <div className="rating">
            <p>{avgrating?.average_rating}</p>
          </div>

          <div className="reiview">
            <p>({avgrating?.total_counts} Reviews)</p>
          </div>
        </div>
      </div>

      <div className="description_container">
        <Product_Description_Text description={props?.product?.description} />

        <div className="footer_btn_holder">
          <div
            className="kilo_main_div"
            onClick={() => {
              set_show_Select_Product_By_Weight_Modal(true);
            }}
          >
            <div className="kilo_div">
              <div>
                <p className="kilo_text">{props?.product?.Product_Variants?.[0]?.name} {props?.product?.Unit?.name}</p>
              </div>
              <div>
                <p>
                  <FontAwesomeIcon icon={faSortDown} className="down_icon" />
                </p>
              </div>
            </div>
          </div>
          <div className="btn_holder">
            {addCartBTNShow ? (
              <IncrementDecrementBtn />
            ) : (
              <Green_Btn
                btn_name="Add to Cart"
                leftIcon={faBasketShopping}
                onClick={() => {
                  dispatch(getAllCart(isSignIn));
                  set_show_Select_Product_By_Weight_Modal(true);
                }}
              />
            )}
          </div>
        </div>

        <Product_Specification product={props?.product} />
      </div>

      {/* <Select_Product_Modal
        modal_title="Make it Combo (Fries & Drink)"
        choose_items="4"
        products={products}
        show={makeItComboModalShow}
        onHide={() => setMakeItComboModalShow(false)}
      /> */}

      <GotoCartModal
        show={showGoToCartModal}
        onHide={() => setshowGoToCartModal(false)}
      />

      <Select_Product_Cart_Modal
        selectedVariant={selectedVariant}
        setSelectedVariant={setSelectedVariant}
        product={props?.product}
        show={show_Select_Product_By_Weight_Modal}
        onHide={() => set_show_Select_Product_By_Weight_Modal(false)}
      />

      {/* <Select_Product_Modal
        modal_title="Add dips"
        choose_items="4"
        products={products}
        show={addDipsModalShow}
        onHide={() => setAddDipsModalShow(false)}
      /> */}

      {/* <Close_Without_Adding_To_Cart_Modal
        show={showModal}
        onHide={() => setShowModal(false)}
      /> */}
    </div>
  );
};

export default Product_Inner_Description;
